import styled from 'styled-components';

const StyledFoldersSelectorContainer = styled.div`
  min-height: 324px;
  display: flex;
  flex-direction: column;
`;

const StyledFoldersSelector = styled.div`
  overflow: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  max-height: 240px;
`;

const StyledFolderSelectorHeader = styled.div`
  display: flex;
  background-color: ${props => props.theme.colors.light_dark};
  border-bottom: 2px solid ${props => props.theme.colors.light_darker_1};
  padding: ${props => props.theme.spacing.medium}
    ${props => props.theme.spacing.small};
  height: ${props => props.theme.spacing.xxlarge};
  top: 0;
  z-index: 2;
`;

const StyledFolderSelectorHeaderTitle = styled.div`
  display: flex;
  margin-right: 4px;
  align-items: center;
`;

export {
  StyledFoldersSelector,
  StyledFoldersSelectorContainer,
  StyledFolderSelectorHeader,
  StyledFolderSelectorHeaderTitle,
};
